import { FC } from 'react';

import './styles.scss';

interface BackdropProps {
  visible: boolean;
  onClick?: () => void;
}

const Backdrop: FC<BackdropProps> = ({ visible, onClick }) => (
  <div
    className={`backdrop${visible ? ' backdrop--visible' : ''}`}
    aria-hidden="true"
    onClick={onClick}
  />
);

export { Backdrop };
export type { BackdropProps };
